import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PrivateRoute } from './private-route';
import { BusinessCard } from '../pages';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useGetCardDetails, useGetSchedulerDetails } from '../hooks';
import moment from 'moment/moment';

export const getNormalizeDate = (date) =>
  moment(date, moment.ISO_8601).toDate();

const generateTheme = ({ primary, fontName }) =>
  createTheme({
    typography: {
      fontFamily: fontName || "'Montserrat', sans-serif",
      fontWeightMedium: 600,
    },
    palette: {
      primary: {
        main: primary || '#1555cf',
      },
    },
  });

export const AppRoutes = () => {
  const currentDate = getNormalizeDate(new Date());
  const { data: cardDetails, loading: cardLoading } = useGetCardDetails();
  const { data: schedulerDetails, loading: schedulerDetailsLoading } =
    useGetSchedulerDetails();

  const [fontName, setFontName] = useState(
    localStorage.getItem('font-family') || "'Montserrat', sans-serif"
  );

  useEffect(() => {
    setFontName(
      cardDetails?.current?.config?.seller?.profile?.fontFamily ||
        "'Montserrat', sans-serif"
    );
  }, [cardDetails]);

  return (
    <ThemeProvider
      theme={generateTheme({
        primary:
          cardDetails?.current?.config?.storefront?.general?.primaryColorHex ||
          '#1555cf',
        fontName: fontName,
      })}
    >
      <Routes>
        <Route
          path="*"
          element={
            <PrivateRoute>
              <BusinessCard
                cardDetails={cardDetails}
                cardLoading={cardLoading || schedulerDetailsLoading}
                schedulerEnabled={
                  schedulerDetails?.schedulerConfig?.subscriptionExpiryDate !==
                    null &&
                  getNormalizeDate(
                    schedulerDetails?.schedulerConfig?.subscriptionExpiryDate
                  ) >= currentDate
                }
              />
            </PrivateRoute>
          }
        />
      </Routes>
    </ThemeProvider>
  );
};
